const Resolution = Object.freeze({
    EXCHANGE: 'EXCHANGE',
    REFUND: 'REFUND',
    STORE_CREDIT: 'STORE_CREDIT'
});

export {Resolution};